import Vue from 'vue'
import Vuex from 'vuex'
import { statSync } from 'fs';
import bulkstore from "@/bulk/bulksms-state";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    rootUrl :  "https://api.vaspro.co.ke/v3/", //"http://localhost/vaspro-api/v2/",
    rootURLBulkAPI : "https://api.vaspro.co.ke/",
    rootURLUser: "https://api.vaspro.co.ke/v2/",
    rootUrlLogin :  "https://api.vaspro.co.ke/v2/",
    user:[],
    key:'',
    username:'',
    walletBalance: null,
    accountDetails:"",
    clientUsername:'',
    permission_acl:"",
    user_mapId:"",
    senderIDSelect:[],
    paybillSelect:"",
    paybillResponse:[],
    invoiceSelect:[],
    showCreateMessageContainer: false,
    showCreateSurveyMessage:false,
    composeMessage: "",
    composeSurvey:"",
    selectTemplate:[],
    selectTemplateStatus:"",
    selectedCampaign:[],
    selectedMessageKey:"",
    selectedProfile:[],
    selectKeyword:[],
    selectMoveClientDetails:[],
    selectInboxDetails:[],
    shortCodeSelect:[],
    selectSurvey:[],
    selectQuestion:null,
    surveyStatus:0
  },
  mutations: {
    setUser(state,data){
      state.user=data;
    },
    setUserKey(state,data){
      state.key=data;
    },
    setWalletBalance(state, data){
      state.walletBalance = data
    },
    setUsername(state, data){
      state.username = data
    },
    setClientUsername(state,data){
      state.clientUsername = data
    },
    setAccountDetails(state,data){
      state.accountDetails = data
    },
    setPermission(state,data){
      state.permission_acl = data
    },
    setClientUser_mapId(state,data){
      state.user_mapId = data
    },
    setSenderIDSelect(state,data){
      state.senderIDSelect = data
    },
    setpayBill(state,data){
      state.paybillSelect = data
    },
    setpaybillResponse(state,data){
      state.paybillResponse = data
    },
    setInvoiceSelect(state,data){
      state.invoiceSelect = data
    },
    showCreateMessage(state,data){
      state.showCreateMessageContainer = data
    },
    composeMessageState(state, data){
      state.composeMessage = data
    },
    showCreateSurveyMessage(state,data){
      state.showCreateSurveyMessage = data
    },
    composeSurveyMessageState(state, data){
      state.composeSurvey = data
    },
    setSelectTemplate(state,data){
      state.selectTemplate = data
    },
    setSelectTemplateStatus(state,data){
      state.selectTemplateStatus = data
    },
    setSelectProfileDetails(state,data){
      state.selectedProfile = data
    },
    setKeywordDetails(state,data){
      state.selectKeyword = data;
    },
    setMoveClientDetails(state,data){
      state.selectMoveClientDetails = data;
    },
    setInboxDetails(state,data){
      state.selectInboxDetails = data;
    },
    setShortcodeSelect(state,data){
      state.shortCodeSelect = data;
    },
    setSurveySelect(state,data){
      state.selectSurvey = data;
    },
    setSelectQuestion(state,data){
      state.selectQuestion = data;
    },
    setSurveyStatus(state,data){
      state.surveyStatus = data;
    }
  },
  getters: {
    compMessage(state){
      return state.composeMessage;
    }
  },
  actions: {
    testAction:(context,data) => {
      console.log('action tested');
    },
    
  }
})
